
import React from 'react';
import { Control } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormDescription } from '@/components/ui/form';
import { InfoTooltip } from '../../ui/InfoTooltip';
import { MoneyInput } from '../../ui/MoneyInput';

interface GrossIncomeFieldProps {
  control: Control<any>;
  applicantStatus: string;
}

export function GrossIncomeField({ control, applicantStatus }: GrossIncomeFieldProps) {
  return (
    <FormField
      control={control}
      name="grossIncome"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="flex items-center gap-2">
            Annual Gross Income (€)
            <InfoTooltip content="Include income from all sources: pensions, salary, social welfare, rental income, dividends, etc. For couples, enter your combined income." />
          </FormLabel>
          <FormControl>
            <MoneyInput {...field} />
          </FormControl>
          <FormDescription>
            Your {applicantStatus === 'couple' ? "household's" : "personal"} total income before any deductions.
          </FormDescription>
        </FormItem>
      )}
    />
  );
}
